import { useState } from 'react'

import { isFlagEnabled } from '~/shell/integrations/unleash'

import { type FlagName } from './flagNames'

/**
 * Whether the named feature flag is on for this session.
 *
 * Read once and fixed for the session. Call only below `RequireAuth`, which resolves flags before
 * rendering; outside that tree an unresolved flag reads as off (Atlas ADR-0028).
 */
export const useFlag = (name: FlagName): boolean => {
  const [enabled] = useState(() => isFlagEnabled(name))
  return enabled
}
